export const inclusionsQueryKeys = {
  all: ['inclusions'] as const,
  packageInclusions: () => [...inclusionsQueryKeys.all, 'package'] as const,
  packageInclusionsByOffer: (offerId: string) => [...inclusionsQueryKeys.packageInclusions(), offerId] as const,
  packageInclusionsByDeal: (offerId: string, dealSalesforceId: string, currencyisocode: string) =>
    [...inclusionsQueryKeys.packageInclusionsByOffer(offerId), dealSalesforceId, currencyisocode] as const,
  vendorInclusions: (vendorId: string, offerId: string) =>
    [...inclusionsQueryKeys.all, 'vendor', vendorId, offerId] as const,
};
